// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*,
*::before,
*::after {
  box-sizing: border-box;
}

.welcome-text-container {
  color: #0669B3;
}
.welcome-text-container .accordion {
  margin-bottom: 20px;
}
.welcome-text-container .accordion-header .accordion-button {
  background-color: #F8F8F8;
}
.welcome-text-container .accordion-header h5 {
  color: #0669B3;
  font-size: 1.1rem;
  font-weight: 700;
}
.welcome-text-container .accordion-body {
  background-color: #F8F8F8;
  color: #0669B3;
}
.welcome-text-container .accordion-body .danger {
  color: #CB321A;
}
.welcome-text-container .accordion-body .form-header {
  font-size: 1.2rem;
  font-weight: 600;
  margin-bottom: 10px;
}
.welcome-text-container .accordion-body p {
  font-size: 1rem;
  line-height: 1.1rem;
}
.welcome-text-container .accordion-body ul {
  margin-top: 10px;
}
.welcome-text-container .accordion-body ul > li {
  font-size: 1rem;
  line-height: 1.7rem;
}
.welcome-text-container .accordion-body ul.charter-school-li > li {
  color: #444343;
  font-weight: 550;
}
.welcome-text-container .grey-text {
  color: #444343;
}
.welcome-text-container a {
  color: #0669B3;
  font-weight: 500;
}
.welcome-text-container h4 {
  font-size: 1.2rem;
  font-weight: 700;
  line-height: 1.1rem;
}
.welcome-text-container h5 {
  font-size: 1.1rem;
  font-weight: 700;
  line-height: 1.1rem;
}
.welcome-text-container p {
  font-weight: 500;
  line-height: 1.75rem;
}
.welcome-text-container span.highlight {
  background-color: #FEBF31;
  color: #444343;
  font-weight: 500;
  padding: 0 3px;
}

.spacer {
  height: 60px;
}

.oe-pending-container {
  margin: 20px auto 40px auto;
  max-width: 1000px;
}
.oe-pending-container .oe-pending-hero {
  border-radius: 10px;
  box-shadow: 0.1rem 0.15rem 0.3rem 0 #525151;
  background: linear-gradient(135deg, #ffffff 0%, #F8F8F8 100%);
  border: 1px solid #D1D3D4;
  border-top: 5px solid #0669B3;
  margin-bottom: 24px;
  padding: 30px;
}
.oe-pending-container .oe-pending-hero .oe-header-title {
  color: #19608f;
  font-size: 1.75rem;
  font-weight: 700;
  margin-bottom: 12px;
}
.oe-pending-container .oe-pending-hero .oe-pending-desc {
  color: #444343;
  font-size: 1.05rem;
  line-height: 1.6;
  margin-bottom: 20px;
}
.oe-pending-container .oe-pending-hero .oe-countdown-banner {
  border-radius: 8px;
  align-items: center;
  background-color: #fff9e6;
  border-left: 4px solid #FEBF31;
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  justify-content: space-between;
  padding: 16px 20px;
}
.oe-pending-container .oe-pending-hero .oe-countdown-banner .oe-countdown-text {
  color: #444343;
  font-size: 1rem;
  font-weight: 600;
  margin: 0;
}
.oe-pending-container .oe-pending-hero .oe-countdown-banner .oe-countdown-text .oe-highlight-date {
  color: #19608f;
  font-weight: 700;
}
.oe-pending-container .oe-pending-hero .oe-countdown-banner .oe-countdown-badge {
  border-radius: 20px;
  align-items: center;
  background-color: #FEBF31;
  color: #444343;
  display: inline-flex;
  font-size: 0.95rem;
  font-weight: 700;
  gap: 6px;
  padding: 6px 16px;
  white-space: nowrap;
}
.oe-pending-container .oe-resource-grid {
  display: grid;
  gap: 24px;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  margin-bottom: 24px;
}
.oe-pending-container .oe-resource-grid .oe-resource-card {
  border-radius: 10px;
  box-shadow: 0.1rem 0.15rem 0.3rem 0 #525151;
  background: #ffffff;
  border: 1px solid #D1D3D4;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 24px;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}
.oe-pending-container .oe-resource-grid .oe-resource-card:hover {
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.12);
  transform: translateY(-3px);
}
.oe-pending-container .oe-resource-grid .oe-resource-card .oe-card-content h3 {
  align-items: center;
  color: #0669B3;
  display: flex;
  font-size: 1.25rem;
  font-weight: 700;
  gap: 8px;
  margin-bottom: 10px;
}
.oe-pending-container .oe-resource-grid .oe-resource-card .oe-card-content p {
  color: #444343;
  font-size: 0.95rem;
  line-height: 1.5;
  margin-bottom: 20px;
}
.oe-pending-container .oe-resource-grid .oe-resource-card .oe-card-link {
  border-radius: 6px;
  background-color: #0669B3;
  color: #ffffff;
  display: inline-block;
  font-size: 0.95rem;
  font-weight: 600;
  padding: 10px 18px;
  text-align: center;
  text-decoration: none;
  transition: background-color 0.2s ease;
}
.oe-pending-container .oe-resource-grid .oe-resource-card .oe-card-link:hover {
  background-color: #1786DB;
  color: #ffffff;
}
.oe-pending-container .oe-help-footer {
  border-radius: 8px;
  background-color: #F8F8F8;
  border: 1px dashed #A7A9AC;
  color: #444343;
  font-size: 0.9rem;
  line-height: 1.5;
  padding: 16px 20px;
}
.oe-pending-container .oe-help-footer strong {
  color: #19608f;
}`, "",{"version":3,"sources":["webpack://./src/styles/global/Colors.scss","webpack://./src/styles/WelcomeText.scss","webpack://./src/styles/global/globalMixins.scss"],"names":[],"mappings":"AAAA;;;EAGI,sBAAA;ACCJ;;AADA;EACI,cD6BS;ACzBb;AAFI;EACI,mBAAA;AAIR;AAAQ;EACI,yBDYA;ACVZ;AACQ;EACI,cDiBC;EChBD,iBAAA;EACA,gBAAA;AACZ;AAGI;EACI,yBDCI;ECAJ,cDSK;ACVb;AAGQ;EACI,cDPN;ACMN;AAIQ;EACI,iBAAA;EACA,gBAAA;EACA,mBAAA;AAFZ;AAKQ;EACI,eAAA;EACA,mBAAA;AAHZ;AAMQ;EACI,gBAAA;AAJZ;AAOQ;EACI,eAAA;EACA,mBAAA;AALZ;AAQQ;EACI,cDpBH;ECqBG,gBAAA;AANZ;AAUI;EACI,cD1BC;ACkBT;AAWI;EACI,cD5BK;EC6BL,gBAAA;AATR;AAYI;EACI,iBAAA;EACA,gBAAA;EACA,mBAAA;AAVR;AAaI;EACI,iBAAA;EACA,gBAAA;EACA,mBAAA;AAXR;AAcI;EACI,gBAAA;EACA,oBAAA;AAZR;AAeI;EACI,yBD5DI;EC6DJ,cDrDC;ECsDD,gBAAA;EACA,cAAA;AAbR;;AAiBA;EACI,YAAA;AAdJ;;AAiBA;EACI,2BAAA;EACA,iBAAA;AAdJ;AAgBI;EC/FA,mBDgGuC;EC3EvC,2CAAA;ED6EI,6DAAA;EACA,yBAAA;EACA,6BAAA;EACA,mBAAA;EACA,aAAA;AAdR;AAgBQ;EACI,cDrGF;ECsGE,kBAAA;EACA,gBAAA;EACA,mBAAA;AAdZ;AAiBQ;EACI,cDpFH;ECqFG,kBAAA;EACA,gBAAA;EACA,mBAAA;AAfZ;AAkBQ;ECtHJ,kBDuH2C;EACnC,mBAAA;EACA,yBAAA;EACA,8BAAA;EACA,aAAA;EACA,eAAA;EACA,SAAA;EACA,8BAAA;EACA,kBAAA;AAhBZ;AAkBY;EACI,cDtGP;ECuGO,eAAA;EACA,gBAAA;EACA,SAAA;AAhBhB;AAkBgB;EACI,cDpIV;ECqIU,gBAAA;AAhBpB;AAoBY;EC7IR,mBD8I+C;EACnC,mBAAA;EACA,yBD5HJ;EC6HI,cDrHP;ECsHO,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,QAAA;EACA,iBAAA;EACA,mBAAA;AAlBhB;AAuBI;EACI,aAAA;EACA,SAAA;EACA,2DAAA;EACA,mBAAA;AArBR;AAuBQ;EClKJ,mBDmK2C;EC9I3C,2CAAA;EDgJQ,mBAAA;EACA,yBAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,aAAA;EACA,qDAAA;AArBZ;AAuBY;EACI,0CAAA;EACA,2BAAA;AArBhB;AAyBgB;EACI,mBAAA;EACA,cDvJP;ECwJO,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,QAAA;EACA,mBAAA;AAvBpB;AA0BgB;EACI,cDlKX;ECmKW,kBAAA;EACA,gBAAA;EACA,mBAAA;AAxBpB;AA4BY;ECrMR,kBDsM+C;EACnC,yBDzKH;EC0KG,cAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,qBAAA;EACA,sCAAA;AA1BhB;AA4BgB;EACI,yBDnLD;ECoLC,cAAA;AA1BpB;AAgCI;ECzNA,kBD0NuC;EACnC,yBDtMI;ECuMJ,0BAAA;EACA,cDjMC;ECkMD,iBAAA;EACA,gBAAA;EACA,kBAAA;AA9BR;AAgCQ;EACI,cD/NF;ACiMV","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
